import { UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Col, Collapse, Row, Tooltip } from "antd";
import { FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import PackagesSVG from "../../assets/catalog/PackagesSVG";
import DeleteSVG from "../../assets/common/DeleteSVG";
import VectorSVG from "../../assets/common/VectorSVG";
import EditSVG from "../../assets/teamMember/EditSVG";
import IconSVG from "../../assets/teamMember/IconSVG";
import { Package } from "../../types/package";
import SubInfo from "../admin/common/SubInfo";
import GenderSwitch from "../common/GenderSwitch";

interface PackageItemProps {
  packageItem: Package;
  OwnLayoutStyles: string;
  openModalEdit: (modal: any, data: any) => void;
}

const PackageItem: FC<PackageItemProps> = ({
  packageItem,
  OwnLayoutStyles,
  openModalEdit,
}) => {
  const { Panel } = Collapse;
  const intl = useIntl();

  const getFormatedPricingType = (
    type: "service_price" | "custom_price" | "percentage_discount" | "free"
  ) => {
    let priceType = "";
    switch (type) {
      case "free":
        priceType = intl.formatMessage({ id: "free" });
        break;
      case "custom_price":
        priceType = intl.formatMessage({ id: "custom_price" });
        break;
      case "percentage_discount":
        priceType = intl.formatMessage({ id: "percentage_discount" });
        break;
      case "service_price":
        priceType = intl.formatMessage({ id: "service_price" });
        break;
      default:
        break;
    }
    return priceType;
  };
  return (
    <Collapse
      className={OwnLayoutStyles}
      style={{ margin: "5px 0px" }}
      key={packageItem?.id}
    >
      <Panel
        className={OwnLayoutStyles}
        style={{
          marginBottom: "10px",
          // borderRight: `3px solid ${category.color}`,
          boxShadow: "0px 2px 10px 0px rgba(153, 153, 167, 0.12)",
        }}
        header={
          <div className="grid justify-between grid-cols-3 gap-2 p-2 mt-2 bg-white rounded">
            <div className="flex items-center gap-2">
              <PackagesSVG />

              <div className="px-2 text-black capitalize ">
                {packageItem?.name}
              </div>
            </div>
            <div className="flex justify-center">
              <SubInfo
                value={packageItem?.total_time}
                label={<FormattedMessage id="minutes" />}
              />
            </div>

            <div className="flex justify-end ">
              <SubInfo
                value={
                  packageItem?.retail_price?.formatted ||
                  packageItem?.retail_price
                }
                label={intl.formatMessage({ id: "SARshort" })}
              />
            </div>
          </div>
        }
        key="1"
      >
        <div className="bg-[#FBFBFF] p-2">
          <Row gutter={{ xs: 8, sm: 16, md: 8, lg: 14, xl: 5 }}>
            <Col>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="13"
                viewBox="0 0 17 13"
                fill="none"
              >
                <path
                  d="M15.8857 6.36364C15.7834 6.29546 15.6811 6.26136 15.5788 6.22727C16.1925 5.20455 16.4993 4.31818 16.4993 3.56818C16.4993 1.86364 15.1357 0.5 13.4311 0.5C12.4425 0.5 11.5561 0.943182 11.0107 1.69318C10.4311 0.943182 9.54474 0.5 8.5902 0.5C6.88565 0.5 5.52202 1.86364 5.52202 3.56818C5.52202 4.28409 5.79474 5.10227 6.30611 6.02273C5.93111 6.22727 5.62429 6.53409 5.41974 6.875C5.18111 7.28409 4.77202 7.59091 4.29474 7.65909L2.93111 7.89773V7.45455C2.93111 7.25 2.79474 7.11364 2.5902 7.11364H0.442472C0.237926 7.11364 0.101562 7.25 0.101562 7.45455V12.1591C0.101562 12.3636 0.237926 12.5 0.442472 12.5H2.48793C2.69247 12.5 2.82884 12.3636 2.82884 12.1591V11.8864H7.19247C7.66974 11.8864 8.18111 11.8523 8.65838 11.75L10.6357 11.3409C11.5561 11.1364 12.4084 10.7955 13.1925 10.25L15.9538 8.40909C16.2947 8.17046 16.4993 7.79546 16.4993 7.38636C16.4652 6.97727 16.2607 6.60227 15.8857 6.36364ZM8.52202 1.18182C9.44247 1.18182 10.2607 1.69318 10.6697 2.51136C10.7379 2.61364 10.8402 2.71591 10.9766 2.71591C11.1129 2.71591 11.2152 2.64773 11.2834 2.51136C11.6925 1.69318 12.5107 1.18182 13.4311 1.18182C14.7607 1.18182 15.8175 2.27273 15.8175 3.56818C15.8175 4.31818 15.4425 5.23864 14.7266 6.32955L12.9538 7.25C12.1016 7.69318 11.1129 7.96591 10.1243 8L8.18111 8.06818C8.38565 7.625 8.76065 6.97727 9.3402 6.53409C9.85156 6.125 10.2266 5.57955 10.3629 4.96591V4.93182C10.397 4.69318 10.3288 4.45455 10.1243 4.28409C9.91974 4.14773 9.68111 4.11364 9.44247 4.21591C9.06747 4.38636 8.45383 4.72727 7.70383 5.17046C7.39702 5.375 7.12429 5.51136 6.88565 5.68182C6.44247 4.86364 6.20383 4.14773 6.20383 3.56818C6.13565 2.23864 7.19247 1.18182 8.52202 1.18182ZM2.14702 11.8182H0.783381V7.79545H2.14702V11.8182ZM15.5447 7.86364L12.7834 9.70455C12.0675 10.1818 11.3175 10.4886 10.4652 10.6932L8.48793 11.1023C8.04474 11.2045 7.60156 11.2386 7.19247 11.2386H2.82884V8.57955L4.29474 8.34091C4.97656 8.23864 5.55611 7.82955 5.89702 7.21591C6.03338 6.94318 6.27202 6.73864 6.51065 6.60227L6.78338 6.46591C7.15838 6.26136 7.56747 6.02273 8.01065 5.75C8.69247 5.30682 9.27202 5.03409 9.64702 4.86364C9.54474 5.30682 9.27202 5.71591 8.89702 6.02273C7.80611 6.875 7.36293 8.27273 7.32884 8.34091C7.29474 8.44318 7.32883 8.54545 7.39702 8.64773C7.4652 8.75 7.56747 8.78409 7.66974 8.78409L10.1243 8.71591C11.2152 8.68182 12.272 8.40909 13.2266 7.89773L14.9993 6.97727C15.1697 6.875 15.3743 6.90909 15.5107 6.97727C15.6811 7.07955 15.7834 7.25 15.7834 7.42046C15.7834 7.59091 15.6811 7.76136 15.5447 7.86364Z"
                  fill="#00086D"
                />
              </svg>
            </Col>
            <Col>
              <p>{intl.formatMessage({ id: "package_contents" })}</p>
            </Col>
          </Row>
          <div className="flex justify-between mt-4 mb-5 align-middle">
            <Col>
              <Row
                justify={"space-between"}
                className="p-1 mb-2 bg-white"
                gutter={{ xs: 8, sm: 16, md: 8, lg: 14, xl: 10 }}
              >
                <Col>{intl.formatMessage({ id: "provided_by" })}</Col>
                <Col>
                  <Row>
                    <Col className="px-2">
                      <Avatar.Group
                        size={24}
                        maxCount={4}
                        maxStyle={{
                          color: "#00086d",
                          // height: "24px",
                          // width: "24px",
                          backgroundColor: "#fff",
                        }}
                      >
                        {packageItem?.team_members?.map(
                          (teamMember: any, index: any) => (
                            <Tooltip
                              title={teamMember?.name}
                              placement="top"
                              key={index}
                            >
                              <Avatar
                                size={24}
                                style={{
                                  // height: "24px",
                                  // width: "24px",
                                  backgroundColor: "#00086d",
                                }}
                                src={teamMember?.media}
                                icon={<UserOutlined />}
                                alt="Ellipse"
                              />
                            </Tooltip>
                          )
                        )}
                      </Avatar.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row
                justify={"space-between"}
                gutter={{ xs: 8, sm: 16, md: 8, lg: 14, xl: 10 }}
                className=""
              >
                <Col className="m-1">
                  <Button
                    type="primary"
                    className="btn-primary-edit"
                    onClick={() => openModalEdit("EditPACKAGE", packageItem)}
                    icon={<EditSVG />}
                  >
                    {intl.formatMessage({ id: "edit_package" })}
                  </Button>
                </Col>
                <Col className="m-1">
                  <Button
                    type="primary"
                    className="btn-primary-danger"
                    danger
                    onClick={() =>
                      openModalEdit(
                        "DELETEPACKAGE",

                        packageItem
                      )
                    }
                    icon={<DeleteSVG />}
                  >
                    {intl.formatMessage({ id: "delete_package" })}
                  </Button>
                </Col>
              </Row>
            </Col>
          </div>
          <Row
            gutter={{ xs: 8, sm: 16, md: 8, lg: 14, xl: 10 }}
            className="mb-4"
          >
            <Col className="pt-2">
              {intl.formatMessage({ id: "available_for" })}
            </Col>
            <Col>
              <GenderSwitch
                disabled
                active={true}
                gender={
                  packageItem?.available_for === "woman"
                    ? "female"
                    : packageItem?.available_for === "man"
                    ? "male"
                    : "both"
                }
                string={intl.formatMessage({
                  id: packageItem?.available_for,
                  defaultMessage: packageItem?.available_for,
                })}
              />
            </Col>
          </Row>
          <div className="flex items-center gap-3 mb-4 ">
            <div>
              <p className="min-w-[90px]">
                {intl.formatMessage({
                  id: "servicesLabel",
                })}
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-2 rounded-md ">
              {packageItem?.pricing_option?.map((item) => (
                <div className="flex items-center gap-2 px-2 py-1 bg-white rounded-md ">
                  <span className="translate-y-0.5">
                    <IconSVG />
                  </span>
                  <p className="min-w-[150px]">{item?.service?.name}</p>
                  <VectorSVG />
                  {/* <p>{item?.service?.service_category_id}</p> //! should be category name 
                   <VectorSVG />
                  */}
                  <div className="min-w-[70px]">
                    <SubInfo
                      value={item?.duration}
                      label={<FormattedMessage id="minutes" />}
                    />
                  </div>
                  <VectorSVG />

                  <SubInfo
                    value={item?.price}
                    label={<FormattedMessage id="SARshort" />}
                  />
                </div>
              ))}
            </div>
          </div>

          <Row className="items-center gap-3">
            <div className="min-w-[90px]">
              <p>{intl.formatMessage({ id: "price" })}</p>
            </div>
            <Col className="py-1 bg-white">
              <Row>
                <Col className="px-2">
                  <div className="flex items-center justify-between gap-2 bg-white rounded">
                    <div className="flex items-center">
                      <div className="flex items-center gap-1">
                        <span>
                          <IconSVG />
                        </span>
                        <span>
                          {getFormatedPricingType(packageItem?.price_type)}
                        </span>
                      </div>
                      <div className="mx-4">
                        <VectorSVG />
                      </div>
                      {packageItem?.price_type === "percentage_discount" ? (
                        <>
                          <div className="flex gap-1 items-center text-[#479821]">
                            <span>
                              {Number(
                                packageItem?.percentage_discount
                              ).toFixed()}
                              %
                            </span>
                          </div>
                          <div className="mx-4">
                            <VectorSVG />
                          </div>
                        </>
                      ) : null}
                      <div className="flex gap-1 items-center text-[#00086D]">
                        <SubInfo
                          value={
                            packageItem?.retail_price?.formatted ||
                            packageItem?.retail_price
                          }
                          label={<FormattedMessage id="SARshort" />}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
};

export default PackageItem;
